// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"5e0dac0f","411":"259a3220","453":"a854e313","944":"946039ea"}[chunkId] + ".chunk.js";
};